<template>
  <div class="MyRes fs20">
    <r_header v-if="!$store.state.mediaPhone"></r_header>
    <div class="detail" v-if="user">
      <div class="group">
        <div
          class="grp fs20"
          v-for="(v, slug) in gameState"
          :key="'grp-btn-'+slug"
          :class="{focus: rewardSlug == slug }"
          @click="focus(slug)">
          {{ dateTitle(slug) }}
        </div>
      </div>
      <div
        class="note fs18"
        v-for="(v, slug) in gameState"
        :key="'note-'+slug"
        :class="{display: rewardSlug == slug }"
      >
        <div class="reward-image" v-if="rw(slug)">
          <div>
          恭喜你在本轮比赛中获奖，下面是你的证书
          </div>
          <certificate :slug="slug" :name="username" :award="rew(slug)" :id="user.id"></certificate>
        </div>
        <div class="center" v-else>
          <div v-if="v.state === 0">
            您并未参加此轮比赛。
          </div>
          <div v-else>
            很遗憾您暂未获奖，请再接再厉，争取在下一轮比赛中取得好成绩！
          </div>
        </div>
        <div class="badging">
          <div>
            大赛组委会
          </div>
          <div>
            {{ dateFooter(slug) }}
          </div>
        </div>
      </div>
      <!-- <div class="info" v-if="user.realname">
           <div v-for="(v, k) in info" class="column">
           <div class="first_line">{{k}}</div>
           <div>{{v}}</div>
           </div>
           </div> -->
      <!--      <div v-else class="certify">-->
      <!--        <certify></certify>-->
      <!--      </div>-->

    </div>

    <div class="detail" v-else>
      请先登录
    </div>
  </div>
</template>

<script>
import Certificate from '@/components/score/Certificate.vue'
import MyImage from '@/components/Image.vue'
import ProfImg from '@/assets/image/score/prof.png'
import SealImg from '@/assets/image/score/aiyouth_seal.png'
/* import SuccProfImg from '@/assets/image/score/succProf.jpg' */
import qrImg from '@/assets/image/score/qrcode.jpeg'
import finalPng from '@/assets/image/score/final.png'
import moment from 'moment'
import SideBar from '@/components/SideBar.vue';
import RHeader from '@/components/frontpage/Header.vue';

export default {
  name: 'EveryRewards',
  props: [],
  computed: {
    links () {
      return this.$store.state.sbar.linksFP
    },
    qr () {
      return qrImg
    },
    finalPng () {
      return finalPng
    },
    game_year() {
      return this.$store.state.game_slug.slice(0, 4)
    },
    gameState () {
      Object.filter = (obj, predicate) =>
        Object.assign(...Object.keys(obj)
                      .filter( key => predicate(key, obj[key]) )
                      .map( key => ({ [key]: obj[key] }) ) );
      return  Object.filter(this.$store.state.auth.game_state, (v) =>{
        return !v.includes('aoc') && !v.includes('cq')
      })
    },
    rewardImg() {
      return ProfImg
    },
    sealImg () {return SealImg;
    },
    user() {
      return this.$store.state.auth.user;

    },
    group() {
      return ['小学组', '初中组', '大学组']
    },
    info() {
      return {
        '姓名': this.user.realname,
        '身份证号': this.user.idcard,
        '地区': this.user.area,
        '组别': this.group[this.user.group-1],
        '参赛单位': this.user.organization? this.user.organization: '个人报名'
      }
    },
    username() {
      return this.user.realname || this.user.name
    },
    title() {
      return {
        'success': '恭喜你已成功晋级全国决赛',
        'failed':'很遗憾你没有晋级全国决赛'
      }
    },
  },
  data() {
    return {
      time: '11月20日',
      QQ: 'QQ群：926470859',
      reward: "计算机科学1级（CS1）证书",
      rewardSlug: ''
    }
  },
  methods: {
    rw (v) {
      if(!this.user) return false
      let vv = this.gameState[v]
      return vv.state >0 && vv.state < 5
    },
    rew (v) {
      let vv = this.gameState[v]
      switch(vv.state) {
        case 1:
          return 'First Prize'
        case 2:
          return 'Second Prize'
        case 3:
          return 'Third Prize'
        default:
          return ''
      }
    },
    focus(f) {
      this.rewardSlug = f;
    },
    dateDate (slug) {
      return (new Date(...((slug || '').split('-').slice(0, 2)),20))
    },
    dateTitle (slug) {
      switch(slug) {
          case '2025-11-1':
          return '初赛阶段'
      }
    },
    dateFooter (slug) {
      return moment(this.dateDate(slug)).format('YYYY年MM月DD日')
    },
    async download() {
      let can = document.getElementById("canvas")
      let blob = await new Promise(resolve=>can.toBlob(resolve));
      let url = URL.createObjectURL(blob);
      let a = document.createElement('a');
      a.href = url;
      a.download = '证书.png';
      a.click();
    },
    calcSN(rank) {
      let r = rank.toString()
      let len = 4-r.length;
      while(len > 0)
      {
        len -= 1;
        r = '0' + r;
      }
      return '2021' + (''+Math.random()).slice(2, 4) + r;
    },
    updateReward () {
      console.log('update reward')
      // this.passed = !this.passed;
    }
  },
  components:{
    r_header: RHeader,
    side_bar: SideBar,
    my_image: MyImage,
    certificate: Certificate
  },
  watch: {
    rewardSlug () {
      this.updateReward();
    },
    gameState () {
      this.rewardSlug = Object.keys(this.gameState)[0];
    }
  },
  mounted()
  {
    if(!this.user) {
      this.$router.push({name:'account', params:{type:'login'}})
    }
    this.rewardSlug = Object.keys(this.gameState)[0];
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.download{
  cursor: pointer;
}
.detail{
  margin-top: 5vh;
  display: flex;
  flex-direction: column;
  align-items:center;
  justify-content:center;
  position: relative;
  margin-bottom: 2vw;
}
.success, .failed{
  color: white;
  background-size: 60vw;
  width: 60vw;
  height: 10vw;
  display:flex;
  justify-content:center;
  align-items:center;
  font-size: 2.3vw;
}
.success{
  background-image: url(~@/assets/image/score/success.png);
}
.failed{
  background-image: url(~@/assets/image/score/failed.png);
}
.info{
  background-image: url(~@/assets/image/score/bg-myinfo.png);
  background-size: 62.3vw;
  width: 62.3vw;
  height: 10.78vw;
  color: white;

  margin-top:4vw;
  box-sizing: border-box;
  padding-left: 4.375vw;
  padding-right: 5.4vw;
  padding-top:1.15vw;
  padding-bottom: 3.125vw;
  display: flex;
}
.column{
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  border-right: solid 1px #7ec5ff;
}
.column:last-child{
  border-right: none !important;
}
.column>div{
  height: 3.25vw;
  display:flex;
  justify-content:center;
  align-items:center;
}
.first_line{
  border-bottom: solid 1px #7EC5FF;
  width: 100%;
}
.certify{
  position: absolute;
  background-color: rgb(255, 255, 255);
  border-radius: 5px;
  box-sizing: border-box;
  padding: 6.3vw 5vw 1vw 2.6vw;
  box-shadow: 1px 1px 5px rgba(0,0,0,0.1);
  height: 100%;
}
.note .content span{
  color:#FE2121;
}
.note .name{
  color: #2F2E38;
  font-weight: 600;
}
.note .content{
  color: #585668;
}
.note .badging{
  color: #585668;
  align-self: flex-end;
}
.note{
  display: none;
  flex-direction: column;
  align-items:flex-start;
  width: 46vw;
}

.note.display {
  display: flex;
}

.reward-image{
  margin-top: 3vw;
  display:flex;
  align-items:center;
  flex-direction: column;
}

.important{
  font-weight: bold;
  display: flex;
  align-items: center;
  margin-top: 1em;
  flex-direction: column;
}
.content{
  text-indent: 2em;
}
.group{
  display: flex;
  align-items:center;
  justify-content: space-around;
  width: 100vw;
  border-bottom: 1px dashed black;
  margin-bottom: 1.5625vw;
  margin-top: 5vw ;
}
.grp{
  line-height: 2.5vw;
}
.focus{
  border-bottom: 1px solid black;
  font-weight: bold;
}
</style>
